import { Injectable } from '@angular/core';
import { CheckoutConnector } from '@spartacus/checkout/base/core';
import { Observable } from 'rxjs';
import { CustomUnavailableProductsAdapter } from './custom-unavailable-products.adapter';

@Injectable({
  providedIn: 'root',
})
export class CustomUnavailableProductsConnector extends CheckoutConnector {
  constructor(protected adapter: CustomUnavailableProductsAdapter) {
    super(adapter);
  }

  public unavailableProducts(
    userId: string,
    cartId: string,
  ): Observable<any[]> {
    return this.adapter.unavailableProducts(userId, cartId);
  }
}
